import React from 'react'
import { TextInput } from '@common/ui'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.entity.field.Field

export type EntityFormDateDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormDateDisplay = ({ field, fieldValue }: EntityFormDateDisplayProps) => {
  const loading = fieldValue === undefined
  return (
    <TextInput
      disabled
      required={field.required}
      label={field.name}
      value={fieldValue?.value ?? ''}
      placeholder={loading ? ' ' : undefined}
    />
  )
}

export default EntityFormDateDisplay
